export default __webpack_public_path__ + "icon-services.c25b09f1550ee2c29f6d30a80ccfe8fd.svg";